// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformSharedLogin = {
  summary:
    "Platform workspaces first take over the current unified identity session, then enter the target control plane.",
  bootstrapTitle: "Checking unified identity session",
  bootstrapDescription:
    "If you already signed in through the portal, this page will detect the current identity.",
  noSessionTitle: "No unified identity session detected",
  noSessionDescription:
    "Please sign in through the portal first, then return to this page to continue into the current workspace.",
  portalAction: "Sign in through Portal",
  enterAction: "Enter with current identity",
  switchIdentityAction: "Switch identity",
  redetectAction: "Recheck unified identity session",
} as const;
